export default __webpack_public_path__ + "static/media/monopoly.a42144fe.webp";